// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gb-overlay{background:rgba(0,16,82,.6)}", "",{"version":3,"sources":["webpack://./src/scss/overlay/overlay-ultium.scss"],"names":[],"mappings":"AAAA,YACC,2BAAA","sourcesContent":[".gb-overlay {\n\tbackground: rgba(0, 16, 82, .6);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
